import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { CoreBotInteractionService } from '../../services/core-bot-interaction-service';
import { AuthService } from '../../services/auth.service';
import { takeUntil } from 'rxjs/operators';
import { CoreBotAuditInteraction } from '../../models/core-bot-audit-interaction';

@Component({
  selector: 'app-audit-interaction-popup',
  templateUrl: './audit-interaction-popup.component.html',
  styleUrls: ['./audit-interaction-popup.component.scss']
})
export class AuditInteractionPopupComponent implements AfterViewInit, OnDestroy {
    @Output() openChatBot: EventEmitter<CoreBotAuditInteraction> = new EventEmitter<CoreBotAuditInteraction>();
    
    isPopupVisible: boolean = false;
    firstSubscription: boolean = true;
    auditInteractions: CoreBotAuditInteraction[];
    
    private unsubscribe$ = new Subject<void>();

    constructor(
        private coreBotInteractionService: CoreBotInteractionService,
        private authService: AuthService
    ){
        this.openChatbot = this.openChatbot.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    ngAfterViewInit(){
        this.coreBotInteractionService.getAuditInteractions().pipe(takeUntil(this.unsubscribe$)).subscribe(interactions => {
            if (!this.firstSubscription){
                this.auditInteractions = interactions;
                this.isPopupVisible = true;
            }
            else {
                this.firstSubscription = false;
            }
        });
    }

    ngOnDestroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    openChatbot() {
        this.openChatBot.emit(this.auditInteractions[0]);
    }

    closePopup() {
        this.isPopupVisible = false;
    }
}
